/**
 * Gunplay: what happens between the trigger and the target.
 */

import type { PerkBranch } from '@/sim/progression/perkBranchContract';

export const GUNPLAY_BRANCH = {
  id: 'gunplay',
  title: 'Gunplay',
  blurb: 'Halcyon certified instruction in the safe operation of your sidearm.',
} as const satisfies PerkBranch;
